<template>
  <span class="company-name-getter" v-if="isLoading">{{ i18n.lbl_loading() }}</span>
  <span class="company-name-getter" v-else>{{ companyName || id }}</span>
</template>

<script>
  import { usersService } from '@api/users.service'
  import { i18n } from '@js/i18n'
  import get from 'lodash/get'
  export default {
    props: ['id'],
    data: _ => ({
      companyData: null,
      isLoading: false,
      i18n
    }),
    async created () {
      await this.getCompanyData()
    },
    computed: {
      companyName () {
        if (!this.companyData) return null
        return get(this.companyData, 'company_name', '-')
      }
    },
    methods: {
      async getCompanyData () {
        this.isLoading = true
        try {
          this.companyData = (await usersService.blobsOf(this.id).getAll())[0]
        } catch (e) {
          console.error(e)
        }
        this.isLoading = false
      }
    },
    watch: {
      async id () {
        await this.getCompanyData()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/vue/app/common/CompanyNameGetter.vue